import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DeltaDate, DurationService } from 'src/app/services/duration.service';
import { Duration } from 'src/app/services/jsonrpc/user-server.service';

@Component({
  selector: 'duration-picker',
  templateUrl: './duration-picker.component.html',
  styleUrls: ['./duration-picker.component.scss']
})
export class DurationComponent implements OnInit {
  @Input() public value: any;
  @Output() public valueChange = new EventEmitter<Duration>();

  public model: DeltaDate;

  constructor(public duration: DurationService) {}

  ngOnInit(): void {
    this.model = { years: 0, months: 0, days: 0 };

    const delta = this.duration.toDuration(this.value);
    this.model.years = delta?.years ?? 0;
    this.model.months = delta?.months ?? 0;
    this.model.days = delta?.days ?? 0;
  }

  public onChange() {
    this.valueChange.emit(this.duration.toIso(this.model));
  }
}
